//Converts an unordered list to paragraphs
//Example: "<ul><li>My text</li></ul>" returns "<p>My text</p>"
//maxBullets: Can be used if you only want to convert single bullets to paragraphs (set this to 1)
//paragraphClass: Can be used to add a class to each p tag
export default function listToParagraphs(value, maxBullets, paragraphClass) {
	let ret = value;
	let convertToParagraphs = maxBullets
		? (value.match(/<li>/g) || []).length <= maxBullets
		: true;

	if (convertToParagraphs) {
		ret = value
			.replace(/<ul>/g, "")
			.replace(/<\/ul>/g, "")
			.replace(
				/<li>/g,
				`<p ${paragraphClass ? `class='${paragraphClass}'` : ""} >`
			)
			.replace(/<\/li>/g, "</p>");
	}

	return ret ? ret : "";
}
